export default "__VITE_PUBLIC_ASSET__899ecda9__"